export default __webpack_public_path__ + "static/media/fx-logo.fe4195f9.svg";